namespace TabAurous.Production {
    export interface JobWorkReceiptBOMForm {
        TransBomId: Serenity.StringEditor;
        ItemTypeId: Serenity.IntegerEditor;
        ProductTypeId: Serenity.LookupEditor;
        CategoryId: CommonCategoryLookup;
        SubCategoryId: CommonSubCategoryLookup;
        ItemType: Serenity.StringEditor;
        BomProductId: Serenity.LookupEditor;
        ProductId: Serenity.StringEditor;
        BagNo: Serenity.StringEditor;
        Line_No: Serenity.StringEditor;
        AttributeId: Serenity.StringEditor;
        ProductCode: Serenity.StringEditor;
        Attribute: Serenity.StringEditor;
        KaratId: Serenity.LookupEditor;
        ShapeId: Serenity.LookupEditor;
        StoneSizeId: Serenity.LookupEditor;
        SieveId: StoneSieveLookup;
        MetalColorId: Serenity.LookupEditor;
        StoneColorId: Serenity.LookupEditor;
        QualityId: Serenity.LookupEditor;
        GroupSieveId: StoneSieveLookup;
        SettingId: Serenity.LookupEditor;
        StoneCutId: Serenity.LookupEditor;
        StonePolishId: Serenity.LookupEditor;
        StoneSymmetryId: Serenity.LookupEditor;
        StoneFluorescenceId: Serenity.LookupEditor;
        StoneCuletId: Serenity.LookupEditor;
        StoneGirdleId: Serenity.LookupEditor;
        StoneTable: Serenity.StringEditor;
        StoneDepth: Serenity.StringEditor;
        Purity: Serenity.DecimalEditor;
        Pieces: Serenity.IntegerEditor;
        Weight: WeightEditor;
        PureWeight: Serenity.DecimalEditor;
        CalcOnId: Serenity.LookupEditor;
        CertificateNo: Serenity.StringEditor;
        BomRate: AmountEditor;
        BomAmount: AmountEditor;
    }

    export class JobWorkReceiptBOMForm extends Serenity.PrefixedContext {
        static formKey = 'Production.JobWorkReceiptBOM';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!JobWorkReceiptBOMForm.init)  {
                JobWorkReceiptBOMForm.init = true;

                var s = Serenity;
                var w0 = s.StringEditor;
                var w1 = s.IntegerEditor;
                var w2 = s.LookupEditor;
                var w3 = CommonCategoryLookup;
                var w4 = CommonSubCategoryLookup;
                var w5 = StoneSieveLookup;
                var w6 = s.DecimalEditor;
                var w7 = WeightEditor;
                var w8 = AmountEditor;

                Q.initFormType(JobWorkReceiptBOMForm, [
                    'TransBomId', w0,
                    'ItemTypeId', w1,
                    'ProductTypeId', w2,
                    'CategoryId', w3,
                    'SubCategoryId', w4,
                    'ItemType', w0,
                    'BomProductId', w2,
                    'ProductId', w0,
                    'BagNo', w0,
                    'Line_No', w0,
                    'AttributeId', w0,
                    'ProductCode', w0,
                    'Attribute', w0,
                    'KaratId', w2,
                    'ShapeId', w2,
                    'StoneSizeId', w2,
                    'SieveId', w5,
                    'MetalColorId', w2,
                    'StoneColorId', w2,
                    'QualityId', w2,
                    'GroupSieveId', w5,
                    'SettingId', w2,
                    'StoneCutId', w2,
                    'StonePolishId', w2,
                    'StoneSymmetryId', w2,
                    'StoneFluorescenceId', w2,
                    'StoneCuletId', w2,
                    'StoneGirdleId', w2,
                    'StoneTable', w0,
                    'StoneDepth', w0,
                    'Purity', w6,
                    'Pieces', w1,
                    'Weight', w7,
                    'PureWeight', w6,
                    'CalcOnId', w2,
                    'CertificateNo', w0,
                    'BomRate', w8,
                    'BomAmount', w8
                ]);
            }
        }
    }
}
